import { render, staticRenderFns } from "./SpotPricingTab.vue?vue&type=template&id=6621e228"
import script from "./SpotPricingTab.vue?vue&type=script&lang=js"
export * from "./SpotPricingTab.vue?vue&type=script&lang=js"
import style0 from "./SpotPricingTab.vue?vue&type=style&index=0&id=6621e228&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports